import styles from './index.module.less';

// const ECanvas = dynamic(() => import("./cpns/E-canvas/index"), {
//   ssr: false,
// });
import ECanvas from './cpns/E-canvas/index';

const countryList = [
  {
    name: 'USA',
    img: 'https://res-front.pumpsoul.com/prod-erasa/image/dmca-takedown/eluosi-1.svg',
  },
  {
    name: 'UK',
    img: 'https://res-front.pumpsoul.com/prod-erasa/image/dmca-takedown/yingguo-2.svg',
  },
  {
    name: 'China',
    img: 'https://res-front.pumpsoul.com/prod-erasa/image/dmca-takedown/china-3.svg',
  },
  {
    name: 'Japan',
    img: 'https://res-front.pumpsoul.com/prod-erasa/image/dmca-takedown/jsapen-4.svg',
  },
  {
    name: 'South Korea',
    img: 'https://res-front.pumpsoul.com/prod-erasa/image/dmca-takedown/hanguo-5.svg',
  },
  {
    name: 'Other',
    img: 'https://res-front.pumpsoul.com/prod-erasa/image/dmca-takedown/ohter-6.svg',
  },
];

const Index: React.FC<{ data: any }> = ({ data }) => {
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{data.contentInfo?.['section-dmca']?.title}</h2>
      <div className={styles.desc}>{data.contentInfo?.['section-dmca']?.desc}</div>
      <ul className={styles.countryList}>
        {countryList.map((item: any) => (
          <li key={item.name}>
            <img src={item.img} alt={item.name} fetchPriority="high" />
            <div className={styles.countryName}>{item.name}</div>
          </li>
        ))}
      </ul>
      <div className={styles.earth}>
        <ECanvas />
      </div>
    </div>
  );
};

export default Index;
